import React from 'react';
import './Clientes-Modal.css'; 
import Video from './assets/HotelHyR/Video.mp4';

const HotelHyR = () => {
    return (
        <div className="container">

            <h2>✅Proyecto: Hostal H&R Construcciones🌞✨</h2>

          
<p>

<video controls>
          <source src={Video} type="video/mp4" />
          Tu navegador no soporta la reproducción de video.
        </video>
        <span className="highlight">
          {' '}
           Energía solar para impulsar el crecimiento del sector turístico: eficiencia, ahorro y sostenibilidad al servicio de los huéspedes.{' '}
        </span>



<br /><br />En el Hostal H&R Construcciones instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 10.01 kWp, compuesto por 14 paneles solares de alta eficiencia y un inversor multicadena de 10 kW, una tecnología ideal para edificaciones con múltiples consumos simultáneos y necesidad de estabilidad energética continua.

<br /><br />Este sistema permite gestionar de manera óptima las cargas eléctricas del hostal iluminación, refrigeración, equipos de recepción y uso constante garantizando una operación estable, confiable y con una reducción del consumo tomado de la red.

<br /><br />Los objetivos de este proyecto fueron:

<br /><br />✔ Reducir el costo operativo asociado al consumo eléctrico.
<br />✔ Fortalecer el compromiso ambiental del establecimiento turístico.
<br />✔ Garantizar energía estable para el funcionamiento diario del hostal y el confort de los huéspedes.

<br /><br />Gracias a esta instalación, el Hostal H&R Construcciones ahora genera parte significativa de su propia energía limpia, logrando ahorros mensuales importantes, una mayor autonomía energética y un valor agregado que mejora la competitividad del establecimiento frente a otros alojamientos de la región.

<br /><br />Este proyecto convierte al hostal en un referente de innovación y sostenibilidad, demostrando que la energía solar es una decisión estratégica para mejorar costos, reputación y responsabilidad ambiental.

<br /><br />Este proyecto cuenta con el acompañamiento de <span className="highlight">IPSUM Ingeniería e Innovación</span>, ofreciendo:

<br /><br />🔧 Soporte técnico y mantenimiento preventivo.
<br />🔧 Monitoreo del sistema para garantizar máxima eficiencia energética.
<br />🔧 Instalación estructural segura, diseñada para prolongar la vida útil del sistema y facilitar el mantenimiento.
<br />🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
<br />🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.
<br /><br />
 <span className="highlight">Una inversión inteligente que combina sostenibilidad, ahorro y un servicio de mayor calidad para los huéspedes.*
      
      </span>

      </p>
        </div>
    );
}

export default HotelHyR;
